import * as React from "react";
import { Col, Row, Button } from "react-bootstrap";
import { ActivityStatusOptions, ActivityStatus } from "../../../../../../server/models/status";
import { SingleSelect } from "../../../parts/select";
import { getErrorMessage } from "../../../../lib/error";
import { ErrorObject } from "../../../../../../server/types/error";

export type ActivityStatusPageProps = {
	status: keyof typeof ActivityStatus;
	onChnage: (status: keyof typeof ActivityStatus) => void;
	onSubmit: () => void;
	errors?: ErrorObject;
};

export const ActivityStatusPage = React.memo((props: ActivityStatusPageProps) => {
	const { status, onChnage, onSubmit, errors } = props;
	return (
		<div className="m-3 clearfix">
			<Row>
				<Col md={12}>
					<div className="h3 float-start">■アクティビティステータス更新</div>
				</Col>
			</Row>
			<Row>
				<Col md={12} className="mb-3">
					<Row className="m-3">
						<Col md={12}>
							<Row className="mt-3">
								<Col md={3} className={"text-end"}>
									ステータス更新：
								</Col>
								<Col>
									<SingleSelect
										options={ActivityStatusOptions}
										value={status ? status.toString() : ""}
										onChange={(value) => {
											onChnage(value as keyof typeof ActivityStatus);
										}}
										error={getErrorMessage("status", errors)}
									/>
								</Col>
							</Row>
						</Col>
					</Row>
				</Col>
			</Row>
			<Row className="mt-5">
				<Col className="text-center">
					<Button variant="secondary" onClick={onSubmit}>
						変更する
					</Button>
				</Col>
			</Row>
		</div>
	);
});
